import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import EditSite from "../../components/Config/EditSite";
import { useTranslation } from "react-i18next";

const ConfigEditSite = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("config.title"),
					component: (
						<>
							<EditSite />
						</>
					),
				}}
				right={null}
			/>
		</>
	);
};

export { ConfigEditSite };
